import { postRequest } from "../../Apis/apiWrapper";
import { templateEndpoints } from "../../utils/constants/httpConstants";

export const generateOpenAIResponse = async ({provider, prompt, model }) => {
  try {
    const payload = {
      provider: provider,
      model: model,
      messages: [
        { role: "system", content: "You are a helpful AI assistant." },
        { role: "user", content: prompt },
      ],
    };

    const response = await postRequest(
      null,
      templateEndpoints.aiGenerate,
      payload,
      {}
    );

    if (!response?.data?.status) {
      throw new Error(response?.data?.message || "AI generation failed");
    }

    return response.data.data.content; // ← FINAL GENERATED OUTPUT
  } catch (err) {
    console.error("AI generation failed:", err);
    throw err;
  }
};
